<!-- grid template -->
<div class="container mx-auto max-w-5xl" *ngIf="isBrowser && !loading">
  <div
    class="mb-3 grid grid-cols-1 space-y-3 md:my-20 md:grid-cols-2 md:gap-x-3 md:space-y-0">
    <!-- grid 1 -->
    <div class="order-1 mb-3 hidden h-[75px] md:order-1 md:block">
      <div
        class="font-playfair-display text-4xl leading-9 text-primary-md-dark">
        BEAUTY <br />
        BOOK
      </div>
    </div>
    <!-- grid 2 -->
    <div class="md:order-2 md:mt-5">
      <!-- <div
        class="mx-auto flex max-w-2xl items-center justify-center gap-4 md:justify-between">
        <div
          class="flex-none bg-primary-md-dark py-2 px-7 text-2xl font-bold text-white">
          LIPS
        </div>
        <div class="flex-1">
          <div class="p-input-icon-right w-full flex-1">
            <input
              pInputText
              type="text"
              class="w-full rounded-full border-[0.5px] border-primary-md-dark py-[7px] px-4 text-primary-md-dark"
              placeholder="Search product"
              fcDebounceKeyup />
            <i id="ps" class="pi pi-search text-primary-md-dark"></i>
          </div>
        </div>
      </div> -->
    </div>
    <!-- grid 3 -->
    <div class="order-2 md:order-4">
      <div
        class="mx-auto max-w-2xl rounded-lg bg-primary-light p-5 md:rounded-b-none">
        <div class="product flex w-full gap-x-2 space-x-2">
          <img
            class="h-16 w-16 md:h-36 md:w-36"
            [src]="
              beautybookProduct.product.default_image_path[0].small.path
            " />
          <div class="info flex w-full flex-col">
            <div
              class="caption w-[45%] rounded-full bg-primary-md-dark py-0.5 text-center text-lg text-white">
              {{ product.product.brand_name }}
            </div>
            <div
              class="caption flex-1 pb-3 text-lg font-semibold text-primary-darkest line-clamp-3 md:mt-1">
              {{ beautybookProduct.product.name }}
            </div>
            <button
              *ngIf="selectedBeautybookProductVariant && selectedSelfie"
              type="button"
              (click)="addToCart()"
              class="variant w-full bg-primary-darkest px-5 py-3 text-xs font-bold text-white">
              <fa-icon [icon]="faCartShopping"></fa-icon>
              Add
              {{ selectedBeautybookProductVariant.productable.variant_name_1 }}
              To Cart
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- grid 4 -->
    <div class="order-4 md:order-5">
      <div
        class="mx-auto grid max-w-2xl grid-cols-5 gap-x-2 rounded-lg bg-primary-light p-5 md:mt-5 md:rounded-t-none">
        <div
          (click)="selectBeautybookProductVariant(variant)"
          *ngFor="let variant of beautybooKProductVariants"
          class="product cursor-pointer">
          <img
            [ngClass]="{
              'border-2 border-primary-md-dark':
                selectedBeautybookProductVariant === variant
            }"
            [src]="variant.productable.array_images[0].small.path"
            class="h-20 w-20" />
        </div>
      </div>
      <div class="mx-auto mt-5 max-w-2xl px-3 md:p-0">
        <div class="p-input-icon-right mx-auto w-full flex-1">
          <textarea
            type="text"
            #caption
            class="h-full min-h-full w-full rounded-lg border-[0.5px] border-primary-md-dark py-[7px] px-4 text-primary-md-dark"
            placeholder="How's the look?"
            fcDebounceKeyup></textarea>
        </div>
        <div class="mt-3 flex justify-end">
          <button
            (click)="submit(caption.value)"
            type="button"
            class="rounded-lg bg-primary-darkest py-3 px-7 font-bold text-white">
            POST
          </button>
        </div>
      </div>
    </div>
    <!-- grid 5 -->
    <!-- menu if selfie uploaded -->
    <div
      *ngIf="selectedSelfie"
      class="relative order-3 mx-auto max-w-2xl md:order-3 md:row-span-2 md:mx-0 md:mt-5 md:w-full md:max-w-[28rem]">
      <div class="absolute right-1 flex flex-col items-end">
        <!-- <div
          class="m-2 h-20 w-20 rounded-full bg-white pt-5 text-center text-3xl text-secondary-dark hover:cursor-pointer hover:bg-secondary-dark hover:text-white md:h-12 md:w-12 md:pt-2 md:text-xl"
          *ngFor="let menu of menus">
          <fa-icon [icon]="menu.icon"></fa-icon>
        </div> -->
        <div
          (click)="openSelectSelfieModal()"
          class="group m-2 flex h-16 w-16 justify-center gap-3 rounded-full bg-white pt-5 text-center text-3xl text-secondary-dark hover:w-auto hover:cursor-pointer hover:bg-secondary-dark hover:px-3 hover:text-white md:h-12 md:w-12 md:pt-2 md:text-xl">
          <fa-icon [icon]="faImagePortrait"></fa-icon>
          <span class="hidden group-hover:block">Select Selfie</span>
        </div>
        <div
          (click)="openUploadSelfieModal()"
          class="group m-2 flex h-16 w-16 justify-center gap-3 rounded-full bg-white pt-5 text-center text-3xl text-secondary-dark hover:w-auto hover:cursor-pointer hover:bg-secondary-dark hover:px-3 hover:text-white md:h-12 md:w-12 md:pt-2 md:text-xl">
          <fa-icon [icon]="faFileArrowUp"></fa-icon>
          <span class="hidden group-hover:block">Upload Selfie</span>
        </div>
      </div>

      <img *ngIf="!resultImage" [src]="selectedSelfie.path" alt="" />
      <div
        *ngIf="isProcessingMakeup"
        class="absolute top-0 left-0 flex h-full w-full items-center justify-center bg-gray-600/60 text-3xl text-white">
        Processing ...
      </div>
      <img *ngIf="resultImage" [src]="resultImage" alt="" />
      <div *ngIf="resultImage" class="text-right text-xs">
        * Gambar bersifat referensi, hasil dapat berbeda
      </div>
    </div>
    <!-- end menu when selfie uploaded -->
    <!-- menu if selfie hasen't been uploaded -->
    <div
      *ngIf="!selectedSelfie"
      class="relative order-3 mx-auto max-w-2xl md:order-3 md:row-span-2 md:mx-0 md:mt-5 md:w-full md:max-w-[28rem]">
      <div
        class="absolute mx-10 mt-[35%] sm:translate-x-0 md:mx-16 md:translate-x-0">
        <div
          class="mx-10 my-2 text-center text-2xl font-bold text-white md:text-xl">
          Upload Your Selfie and Try On Our Products!
        </div>
        <div class="flex justify-center gap-2 text-sm font-bold">
          <button
            (click)="openUploadSelfieModal()"
            type="button"
            class="rounded-md border bg-white px-5 py-2 text-primary-darkest hover:border-primary-darkest hover:bg-primary-darkest hover:text-white">
            Upload Selfie
          </button>
          <button
            (click)="openSelectSelfieModal()"
            type="button"
            class="rounded-md border bg-white px-5 py-2 text-primary-darkest hover:border-primary-darkest hover:bg-primary-darkest hover:text-white">
            Saved Selfies
          </button>
        </div>
      </div>
      <img src="assets/images/beautybook/dummy-selfie-placeholder.png" alt="" />
    </div>
    <!-- end menu when selfie hasen't been uploaded -->
    <!-- grid 6 -->
    <div
      class="order-6 mt-10 w-full px-3 text-secondary-dark md:order-6 md:col-span-2">
      <div class="my-3 flex justify-between">
        <a class="text-xl font-bold">Try another products</a>
        <!-- <a
          [routerLink]="'/beautybook/add'"
          class="text-sm font-semibold hover:text-secondary-main"
          >See All Products</a
        > -->
      </div>
      <div class="grid grid-cols-1 gap-3 md:grid-cols-3">
        <div
          *ngFor="let beautybookProduct of otherBeautybookProducts"
          class="mx-auto w-full max-w-2xl rounded-xl bg-secondary-lightest p-5 hover:-translate-y-2 hover:duration-300 md:max-w-md">
          <div
            class="flex w-full cursor-pointer gap-x-2 space-x-2"
            (click)="navigateToBeautybookProduct(beautybookProduct.id)">
            <img
              class="h-24 w-24"
              [src]="
                beautybookProduct.product.default_image_path[0].small.path
              " />
            <div class="info">
              <!-- <div
                class="variant w-fit rounded-l-full rounded-r-full bg-secondary-dark px-3 py-1 text-sm text-white">
                {{ beautybookProduct.product.brand_name }}
              </div> -->
              <div
                class="caption mt-1 text-lg font-semibold text-secondary-dark line-clamp-3">
                {{ beautybookProduct.product.name }}
              </div>
              <div class="text-gray-600">
                {{ beautybookProduct.beauty_book_product_variants.length }}
                variants
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- skeleton -->
<div class="container mx-auto max-w-5xl" *ngIf="loading">
  <!-- desktop -->
  <main class="mx-auto mt-10 flex gap-10">
    <p-skeleton class="hidden w-[452px] md:block" height="382px"></p-skeleton>
    <div class="flex-1">
      <div class="mb-3">
        <p-skeleton class="w-full" height="5rem"></p-skeleton>
      </div>
      <div class="mb-3">
        <p-skeleton class="w-full" height="14rem"></p-skeleton>
      </div>
      <p-skeleton class="mb-5 w-full" height="3rem"></p-skeleton>
    </div>
  </main>
  <!-- end desktop -->
</div>
